import React, { FC, useEffect, useState } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import { InstantTabPayload } from '../types';
import { ActiveGeneralSurgeType } from 'models/surge.model';
import { surgeList } from 'utils/constants';

type Props = {
  value: InstantTabPayload;
  setValue: (arg1: InstantTabPayload) => void;
  hideRemoveSurge?: boolean;
  activeSurge?: ActiveGeneralSurgeType;
};

const SurgeApplyNowSection: FC<Props> = ({ value, setValue, hideRemoveSurge, activeSurge }) => {
  const [disableCheckbox, setDisableCheckbox] = useState(true);

  useEffect(() => {
    if (activeSurge) {
      const { logistics_surge = '', logistics_surge_type = '' } = activeSurge;
      setValue({
        logistics_surge,
        logistics_surge_type
      });
      const disable = logistics_surge === '' && logistics_surge_type === '';
      setDisableCheckbox(disable);
    }
  }, [activeSurge]);

  return (
    <div className='w-full'>
      <div className='md:grid-cols-2 grid w-full gap-y-5 gap-x-3 my-[24px] mt-8'>
        {surgeList.map(({ name, val, be_value }, i) => (
          <Input
            key={i}
            label={`${name}-${val}x`}
            className='p-0 m-0 text-sm w-full'
            type='radio'
            checked={
              String(value?.logistics_surge) === val && value.logistics_surge_type === be_value
            }
            onChange={() => setValue({ logistics_surge: val, logistics_surge_type: be_value })}
            name='surge-list'
          />
        ))}
      </div>
      {!hideRemoveSurge && (
        <Input
          label='Remove surge'
          className='w-full'
          type='checkbox'
          onChange={() =>
            setValue({
              logistics_surge: '1.0',
              logistics_surge_type: 'delivery-surge'
            })
          }
          name='surge-list'
          checked={
            value.logistics_surge === '1.0' &&
            value.logistics_surge_type === 'delivery-surge' &&
            !disableCheckbox
          }
          disabled={disableCheckbox}
        />
      )}
    </div>
  );
};

export default SurgeApplyNowSection;
